module.exports = __webpack_public_path__ + "images/saaremaa/apple-icon-57x57.png";